import Paper from "@mui/material/Paper";

export default Paper;
